import { useEffect, useState } from "react";
import { resolveAttachmentUrl } from "@/lib/utils/attachment-url-resolver";

/**
 * Hook to handle profile picture URLs that can be either:
 * - Attachment IDs (UUIDs) - converted to signed S3 URLs
 * - Filenames (e.g., "image.png") - fetched from S3 by filename
 *
 * Uses a cache to avoid repeated API calls for the same attachment.
 */
export function useProfilePicture(profilePicUrl: string | null | undefined): string | null {
   const [imageUrl, setImageUrl] = useState<string | null>(null);

   useEffect(() => {
      const loadImage = async () => {
         const result = await resolveAttachmentUrl(profilePicUrl);
         setImageUrl(result.url);
      };

      void loadImage();
   }, [profilePicUrl]);

   return imageUrl;
}
